import Error from '../shared/error';
import { APIErrorType } from '../../api';
import Loader from '../shared/loader';
import { useStudentExamsChartData } from '../../hooks/react-query/use-student-exam';
import ProgressChart from './progress-chart';

function ProgressChartContainer() {
  const {
    isError: studentExamIsError,
    error: studentExamError,
    isLoading: studentExamIsLoading,
    data: studentExams
  } = useStudentExamsChartData();

  if (studentExamIsError) {
    const error = studentExamError as APIErrorType;
    return <Error error={error} />;
  }

  if (studentExamIsLoading || !studentExams) return <Loader />;
  if (studentExams.length < 2) {
    return (
      <div className='m-6 text-center text-red-500'>
        <span>برای دیدن </span>
        <span className='font-bold'>نمودار سیر پیشرفت</span>
        <span> باید حداقل در 2 آزمون‌ اخیر از آزمون های دستیاری ۱۴۰۴ شرکت کرده باشید.</span>
      </div>
    );
  }

  return (
    <div className='text-center'>
      <ProgressChart studentExams={studentExams} />
    </div>
  );
}

export default ProgressChartContainer;
